module.exports = __webpack_public_path__ + "img/Certificate.fe3755d1.jpg";